angular.module('models.alertHandlingService', [])
  .factory('alertHandlingService', ['$window', function($window) {
    var self = this;
    var loginPath = '/login';
    self.loginPath = loginPath + '?return_to=' + $window.location.pathname;

    self.unauthorizedErrorMessage = 'You were logged out.' +
      '<a href="' + self.loginPath + '"> Click here </a>' +
      'to log in again.';

    self.formatMessage = function(message) {
      return message.replace('username', 'email');
    };

    self.isUnauthorizedError = function(error) {
      if (error.status) {
        return error.status === 401;
      }
      return false;
    };

    self.showUnauthorizedMessage = function() {
      self.printMessage(self.unauthorizedErrorMessage, 'error', { sticky: true });
    };

    self.showErrorMessage = function(message) {
      self.printMessage(message, 'error');
    };

    self.showSuccessMessage = function(message) {
      self.printMessage(message, 'success');
    };

    self.showInfoMessage = function(message) {
      self.printMessage(message, 'info', { sticky: true });
    };

    self.printMessage = function(message, type, options) {
      devex.alerts.showAlert(message, type, options);
    };

    self.showGenericErrorMessage = function() {
      self.showErrorMessage(
        'Something went wrong. Please try again.'
      );
    };

    return this;

  }]);
